import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createCostObj, updateCostObj } from 'redux/costObjs/CostObjsActions';
import CostObjEditorContainer from './CostObjEditorContainer';

const mapStateToProps = ({ costObjs }) => ({
  creatingCostObj: costObjs.creatingCostObj,
  pageState: costObjs.pageState,
  costObj: costObjs.costObj,
  fetchingCostObj: costObjs.fetchingCostObj
});

const mapDispatchToProps = dispatch => ({
  costObjsActions: bindActionCreators({ createCostObj, updateCostObj }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(CostObjEditorContainer);




// WEBPACK FOOTER //
// ./src/components/manageCostObjs/comp/costObjEditorContainer/CostObjEditorContainerConnector.js